<template>
    <v-flex xs12 sm10 md8>
      <v-card class="py-4">
        <v-flex xs12 px-4 v-if="err">
          <v-alert type="error" :value="true">{{err}}</v-alert>
        </v-flex>
        <v-flex xs12 px-4 v-if="success">
          <v-alert type="success" :value="true">{{success}}</v-alert>
        </v-flex>
        <v-form v-model="valid">
          <v-flex xs12 md6 px-4>
            <v-autocomplete
              :items="companies"
              :label="$lang.actions.selectCompany"
              :readonly="isEdit"
              v-model="companyId"
              item-text="name"
              item-value="id"
              required
              :loading="companyLoading"
              :rules="[v => !!v || `${$lang.errors.missingCompany}`]"
            />
          </v-flex>
          <v-layout row wrap class="px-2">
            <v-flex xs12 md6 px-3>
              <v-text-field
                label="Domain Name"
                v-model="domainName"
                :rules="[v => !!v || `${$lang.errors.missingDomain}`]"
                required
              />
            </v-flex>
            <v-flex xs12 md6 px-3>
              <v-autocomplete
                :items="types"
                :label="$lang.labels.domainType"
                v-model="domainType"
                :loading="domainLoading"
                :rules="[v => !!v || `${$lang.errors.missingDomainType}`]"
                required
              />
            </v-flex>
            <v-flex xs12 md6 px-3>
              <v-menu
                ref="menu"
                :close-on-content-click="false"
                v-model="menu"
                :nudge-right="40"
                :return-value.sync="registeredOn"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  required
                  :rules="[v => !!v || `${$lang.errors.missingRegisteredOn}`]"
                  slot="activator"
                  v-model="formattedRegisteredOn"
                  label="Registration Date"
                  prepend-icon="event"
                  readonly
                />
                <v-date-picker v-model="registeredOn" @input="$refs.menu.save(registeredOn)" no-title scrollable color="primary" />
              </v-menu>
            </v-flex>
            <v-flex xs12 md6 px-3>
              <v-menu
                ref="menu2"
                :close-on-content-click="false"
                v-model="menu2"
                :nudge-right="40"
                :return-value.sync="deregisteredOn"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="formattedDeregisteredOn"
                  label="Deregistration Date"
                  prepend-icon="event"
                  readonly
                />
                <v-date-picker v-model="deregisteredOn" @input="$refs.menu2.save(deregisteredOn)" no-title scrollable color="primary"/>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-form>
        <v-layout row wrap justify-space-between class="px-2">
          <v-flex xs12 md6 px-3>
            <v-text-field
              v-if="isEdit && createdOn"
              :label="$lang.labels.created"
              v-model="createdOn"
              readonly
            />
          </v-flex>
          <v-flex xs12 md6 px-3>
            <v-text-field
              v-if="isEdit && modifiedOn"
              :label="$lang.labels.modified"
              v-model="modifiedOn"
              readonly
            />
          </v-flex>
        </v-layout>
        <v-layout row justify-space-between class="px-2">
          <v-btn flat class="mx-3" @click="$router.push({ name: 'domains' })"><v-icon>keyboard_arrow_left</v-icon> Close</v-btn>
          <v-btn class="primary mx-3" :disabled="!valid" @click="submit()">{{ isEdit ? $lang.actions.update : $lang.actions.create}}</v-btn>
        </v-layout>
      </v-card>
    </v-flex>
</template>

<script>
  import * as fetch_data from '../../assets/fetch_data';
  import {baseUrl} from '../../assets/url';
  import {DateTime} from 'luxon';

  export default {
    data: () => ({
      err:'',
      isEdit: false,
      success: '',
      valid: false,
      companies: [],
      companyLoading: true,
      companyId: null,
      types: [],
      domainLoading: true,
      domainType: null,
      domainName: '',
      registeredOn: '',
      deregisteredOn: '',
      menu: false,
      menu2: false,
      createdOn: '',
      modifiedOn: '',
    }),
    computed: {
      filteredTypes() {
        return this.filterTypes.length === 0 ? this.types : this.types.filter(type =>
          type.toLowerCase().includes(this.filterTypes.toLowerCase()));
      },
      formattedRegisteredOn() {
        return !this.registeredOn ? null : DateTime.fromISO(this.registeredOn).toFormat('yyyy-MM-dd HH:mm');
      },
      formattedDeregisteredOn() {
        return !this.deregisteredOn ? null : DateTime.fromISO(this.deregisteredOn).toFormat('yyyy-MM-dd HH:mm');
      },
    },
    watch: {
      err(val) {
        if (val !== '') {
          setTimeout(() => { this.err = ''; }, 5000);
        }
      },
    },
    methods: {
      formatDate(date) {
        return DateTime.fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
      },
      fetchCompanies() {
        return new Promise((resolve) => {
          fetch(`${baseUrl}/company`, {
            method: 'get',
            credentials: 'include',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json;charset=UTF-8'
            },
          }).then((response) => {
            return response.json();
          }).then((data) => {
            if(data.error & data.error === 'Forbidden'){
              this.$router.push({ name: 'logout' })
              return;
            }
            this.companyLoading = false;
            this.companies = data.companies;
            resolve();
          }).catch((e) => {
            this.companyLoading = false;
            this.err = 'Failed to fetch companies';
            resolve();
          })
        })
      },
      fetchDomainById(id) {
        fetch(`${baseUrl}/domain/${id}`, {
          method: 'get',
          credentials: 'include',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8'
          },
        }).then((response) => {
          return response.json();
        }).then((data) => {
          if(data.error & data.error === 'Forbidden'){
            this.$router.push({ name: 'logout' })
            return;
          }
          this.isEdit = true;
          this.companyId = data.domain.companyId;
          this.domainName = data.domain.domain; 
          this.domainType = data.domain.type;
          this.registeredOn = data.domain.registeredOn;
          this.deregisteredOn = data.domain.deregisteredOn;
          this.createdOn = this.formatDate(data.domain.createdOn);
          if (data.domain.modifiedOn) {
            this.modifiedOn = this.formatDate(data.domain.modifiedOn);
          }
        }).catch((e) => {})
      },
      fetchTypes() {
        fetch(`${baseUrl}/system/domain/fetchtypes`, {
          method: 'get',
          credentials: 'include',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8'
          },
        }).then((response) => {
          return response.json();
        }).then((data) => {
          if(data.error & data.error === 'Forbidden'){
            this.$router.push({ name: 'logout' })
            return;
          }
          this.domainLoading = false;
          this.types = process.env.NODE_ENV === 'development' ?
            ['.com', '.uk'] :
            data.types;
          localStorage.setItem('types', JSON.stringify(data.types));
        }).catch((e) => {
          this.domainLoading = false;
          this.err = 'Failed to fetch domain types';
        })
      },
      submit(){
        if (
          !this.companyId ||
          !this.domainName ||
          !this.domainType ||
          !this.registeredOn
        ) return;
        const data = {
          domain: this.domainName,
          type: this.domainType,
          registeredOn: this.registeredOn,
          deregisteredOn: this.deregisteredOn,
        };
        if (!this.isEdit) {
          Object.assign(data, { companyId: this.companyId });
        }
        const url = this.isEdit ?
          `${baseUrl}/domain/update/${this.$route.params.id}` :
          `${baseUrl}/domain/create`;
        this.$http.post(url, data)
          .then((res) => {
            if(res.body.status === 'Success') {
              this.success = res.body.statusText;
              setTimeout(() => {
                this.success = '';
                this.$router.push({ name: 'domains' }); 
              }, 3000);
              return;
            }
          }).catch((e) => {
            this.err = 'Failed to submit domain';
          })
      },
    },
    created(){
      this.fetchTypes();
      this.fetchCompanies()
        .then(() => {
          if (this.$route.params.id) {
            this.fetchDomainById(this.$route.params.id);
          }
        });
    },
  };
</script>



// WEBPACK FOOTER //
// NewDomain.vue?613b9bb3